import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { TStaff } from 'entities/staff/model/types';

import cls from './ObserverItem.module.css';
import { Icon } from '../../../shared/ui';

interface ObserverItemProps {
    toggleDropdown: () => void;
    selectedStaff: TStaff[];
    isDisabled: boolean;
}

export const ObserverItem = ({ toggleDropdown, selectedStaff, isDisabled }: ObserverItemProps) => {
    const { t } = useTranslation();
    if (selectedStaff.length === 0) {
        return null;
    }
    return (
        <>
            {selectedStaff.length === 1 && (
                <span className={cls.observersOne}>
                    {!selectedStaff[0].avatar_url ? (
                        <span className={cls.observerAvatar}>
                            <Icon iconName="profile" />
                        </span>
                    ) : (
                        <img
                            className={cls.observerAvatar}
                            src={selectedStaff[0].avatar_url}
                            alt={`${t('Features.ObserverItem.imgAlt.text')} ${
                                selectedStaff[0].name
                            }`}
                        />
                    )}
                </span>
            )}
            {selectedStaff.length === 2 && (
                <div className={cls.observersTwo}>
                    {!selectedStaff[0].avatar_url ? (
                        <span className={cls.observerAvatar}>
                            <Icon iconName="profile" />
                        </span>
                    ) : (
                        <img
                            className={cls.observerAvatar}
                            src={selectedStaff[0].avatar_url}
                            alt={`${t('Features.ObserverItem.imgAlt.text')} ${
                                selectedStaff[0].name
                            }`}
                        />
                    )}
                    {!selectedStaff[1].avatar_url ? (
                        <span className={cls.observerAvatar}>
                            <Icon iconName="profile" />
                        </span>
                    ) : (
                        <img
                            className={cls.observerAvatar}
                            src={selectedStaff[1].avatar_url}
                            alt={`${t('Features.ObserverItem.imgAlt.text')} ${
                                selectedStaff[1].name
                            }`}
                        />
                    )}
                </div>
            )}
            {selectedStaff.length > 2 && (
                <span className={cls.observersTwoMore}>
                    {!selectedStaff[0].avatar_url ? (
                        <span className={cls.observerAvatar}>
                            <Icon iconName="profile" />
                        </span>
                    ) : (
                        <img
                            className={cls.observerAvatar}
                            src={selectedStaff[0].avatar_url}
                            alt={`${t('Features.ObserverItem.imgAlt.text')} ${
                                selectedStaff[0].name
                            }`}
                        />
                    )}
                    <span className={cls.observersCounter}>+{selectedStaff.length - 1}</span>
                </span>
            )}
            <ul className={cn(cls.observerList, isDisabled && cls.disabled)}>
                {selectedStaff.map((staff, i, arr) => (
                    <li
                        key={staff.id}
                        onClick={toggleDropdown}
                        className={cn(cls.observerItem, isDisabled && cls.disabled)}
                    >
                        <span className={cls.observerName}>
                            {staff.name}
                            {i < arr.length - 1 && arr.length > 1 && ', '}
                        </span>
                    </li>
                ))}
            </ul>
        </>
    );
};
